import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  updateRltWorkOrderCache,
  useRltWorkOrderResetReferenceNumberMutation,
  useRltWorkOrderPatchMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * WorkOrderReferenceNumberInput edits the reference number of a work order.
 * Renders nothing for the work order of a commitment, which never has a
 * reference number. A work order without a number yet shows the empty field,
 * so the generated number can be taken over.
 */
export function WorkOrderReferenceNumberInput({
  workOrder,
}: {
  workOrder: WorkOrder;
}) {
  const patchReferenceNumber = useRltWorkOrderPatchMutation();
  const resetReferenceNumber = useRltWorkOrderResetReferenceNumberMutation();

  if (workOrder.commitmentId) {
    return null;
  }

  return (
    <ReferenceNumberField
      data={workOrder}
      updateCache={updateRltWorkOrderCache}
      patchMutation={patchReferenceNumber}
      resetMutation={resetReferenceNumber}
      disabled={isImmutable(workOrder)}
    />
  );
}
